// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { funkiSepolia as _funkiSepolia } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the funkiSepolia chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 3397901
 * Chain Name: Funki Sepolia Sandbox
 * Default Block Explorer: https://sepolia-sandbox.funkichain.com/
 * Default RPC URL: https://funki-testnet.alt.technology
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { funkiSepolia } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: funkiSepolia,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const funkiSepolia = createCommon({
	..._funkiSepolia,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
